import request from '@/utils/request'
import axios from 'axios'

export function imgtemplate_list_req( query ){
  return request({
    url:  '/lenstemplate/list',
    method: 'get',
    params: query,
  })
}

//


export function add_task_req( data ){
  return request({
    url:  '/task/imgbeauty',
    method: 'post',
    data: data,
  })
}

